import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step6({ prevStep, nextStep, updateFieldValue, value }) {

    const [number, setNumber] = useState(value);
    const [error, showError] = useState(false)

    const handleNextStep = () => {
        if (number === "") {
            showError(true)
        } else {
            updateFieldValue("creditScore", number)
            nextStep(6)
        }
    }

    const handleForward = (v) => {
        setNumber(v)
        updateFieldValue("creditScore", v)
        nextStep(6)
    }


    return (

        <div id="step6">
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-6'>What's your estimated credit score?</legend>
                    <div className='mt-5 ml-2 text-base text-gray-800'>
                        <div className='py-1'>
                            <input type="radio" id="creditScore-1" defaultChecked={value === "300 - 579"} onClick={() => handleForward("300 - 579")} name="credit_score" value="300 - 579" />
                            <label htmlFor="creditScore-1" className='ml-2'>300 - 579</label></div>
                        <div className='py-1'>
                            <input type="radio" id="creditScore-2" defaultChecked={value === "580 - 619"} onClick={() => handleForward("580 - 619")} name="credit_score" value="580 - 619" />
                            <label htmlFor="creditScore-2" className='ml-2'>580 - 619</label></div>
                        <div className='py-1'>
                            <input type="radio" id="creditScore-3" defaultChecked={value === "620 - 739"} onClick={() => handleForward("620 - 739")} name="credit_score" value="620 - 739" />
                            <label htmlFor="creditScore-3" className='ml-2'>620 - 739</label></div>
                        <div className='py-1'>
                            <input type="radio" id="creditScore-4" defaultChecked={value === "740 - 799"} onClick={() => handleForward("740 - 799")} name="credit_score" value="740 - 799" />
                            <label htmlFor="creditScore-4" className='ml-2'>740 - 799</label></div>
                        <div className='py-1'>
                            <input type="radio" id="creditScore-5" defaultChecked={value === "800+"} onClick={() => handleForward("800+")} name="credit_score" value="800+" />
                            <label htmlFor="creditScore-5" className='ml-2'>800+</label></div>
                    </div>
                </fieldset>
                {
                    error &&
                    <p className="mt-2 mb-0 text-xs text-red-500 flex">
                        <XCircleIcon className="h-4 w-4 mr-1" /> Please select a value.
                    </p>
                }
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                <button
                    id="calcStep6Prev"
                    onClick={() => prevStep(6)}
                    className="flex items-center h-full w-fit rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    6 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep6Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>
        </div>
    );
}